import { create } from 'zustand'
import { getWorkspaceId } from '@repo/studio-hooks-auth/use-workspace-query'

interface CoinTopUpDialogStore {
  isOpen: boolean
  workspaceId: string | null
}

export const useCoinTopUpDialogStore = create<CoinTopUpDialogStore>(() => ({
  isOpen: false,
  workspaceId: null,
}))

export function openCoinTopUpDialog() {
  useCoinTopUpDialogStore.setState({ isOpen: true, workspaceId: getWorkspaceId() })
}

export function closeCoinTopUpDialog() {
  useCoinTopUpDialogStore.setState({ isOpen: false, workspaceId: null })
}
